// Using vue-imask for masking - https://github.com/uNmAnNeR/imaskjs/tree/master/packages/vue-imask

import IMask from "imask"

const integerMask = function(min, max) {
    return {
        mask: Number,
        min: min,
        max: max,
        scale: 0,
    }
}


const monthYearMask = {
    mask: Date, // enable date mask
    pattern: "m{/}Y", // Pattern mask with defined blocks, default is 'd{.}`m{.}`Y'
    autofix: false,
    lazy: false,
    overwrite: true,

    blocks: {
        m: {
            mask: IMask.MaskedRange,
            from: 1,
            to: 12,
            maxLength: 1,
            placeholderChar: "m",
        },
        Y: {
            mask: IMask.MaskedRange,
            from: 1900,
            to: 2099,
            placeholderChar: "y",
        },
    },
    format: function(date) {
        let month = date.getMonth() + 1
        const year = date.getFullYear()

        if (month < 10) month = "0" + month

        return [month, year].join("/")
    },

    parse: function(str) {
        const monthDayYear = str.split("/")
        return new Date(monthDayYear[1], monthDayYear[0] - 1, 1)
    },
}

const monthYear2Mask = {
    mask: Date, // enable date mask
    pattern: "m{/}Y", // Pattern mask with defined blocks, default is 'd{.}`m{.}`Y'
    autofix: false,
    lazy: false,
    overwrite: true,

    blocks: {
        m: {
            mask: IMask.MaskedRange,
            from: 1,
            to: 12,
            maxLength: 1,
            placeholderChar: "m",
        },
        Y: {
            mask: IMask.MaskedRange,
            from: 20,
            to: 99,
            placeholderChar: "y",
        },
    },
    format: function(date) {
        let month = date.getMonth() + 1
        const year = ("" + date.getFullYear()).substring(2)

        if (month < 10) month = "0" + month

        return [month, year].join("/")
    },

    parse: function(str) {
        const monthDayYear = str.split("/")
        return new Date(2000 + parseInt(monthDayYear[1]), monthDayYear[0] - 1, 1)
    },
}

const localDateMask = {
    mask: Date, // enable date mask
    pattern: "m{/}`d{/}`Y", // Pattern mask with defined blocks, default is 'd{.}`m{.}`Y'
    autofix: false,
    lazy: false,
    overwrite: true,

    blocks: {
        d: {
            mask: IMask.MaskedRange,
            from: 1,
            to: 31,
            maxLength: 2,
            placeholderChar: "d",
        },
        m: {
            mask: IMask.MaskedRange,
            from: 1,
            to: 12,
            maxLength: 1,
            placeholderChar: "m",
        },
        Y: {
            mask: IMask.MaskedRange,
            from: 1900,
            to: 2099,
            placeholderChar: "y",
        },
    },
    format: function(date) {
        let day = date.getDate()
        let month = date.getMonth() + 1
        const year = date.getFullYear()

        if (day < 10) day = "0" + day
        if (month < 10) month = "0" + month

        return [month, day, year].join("/")
    },

    parse: function(str) {
        const monthDayYear = str.split("/")
        return new Date(monthDayYear[2], monthDayYear[0] - 1, monthDayYear[1])
    },
}

class StarMask extends IMask.MaskedRegExp {
    constructor(_) {
        super(_)
        this.re = /\d/
        this.x = "*"
    }

    /**
     * Returns X
     */
    get value() {
        return this._value === "" ? "" : this.x
    }

    /**
     * Return actual value
     */
    get unmaskedValue() {
        return this._value
    }

    /**
     * @internal
     */
    _update(_opts) {
    }

    /**
     * Validates internal value
     * @internal
     */
    validate(_) {
        return this._value.search(this.re) >= 0
    }

    /**
     * Return actual value
     * @internal
     */
    extractInput() {
        return this._value
    }
}

const getBankCardMask = function (cardNumber, showCreditCardNumber) {
    const association = cardNumber?.substring(0, 1)
    if (association === '3') {
        return showCreditCardNumber ? this.amexCardNumber : this.hiddenAmexCreditCardNumberMask
    } else {
        return showCreditCardNumber ? this.creditCardNumber : this.hiddenCreditCardNumberMask
    }
}

export default {
    getBankCardMask: getBankCardMask,
    anyNonNegativeInteger: integerMask(0),
    domainKey: {
        mask: /^[a-zA-Z0-9- ]+$/,
        prepare: function(str) {
            return str.toLowerCase().replace(/\s+/g, "-")
        },
    },
    hiddenAmexCreditCardNumberMask: "xxxx-xxxxxx-00000",
    hiddenCreditCardNumberMask: "xxxx-xxxx-xxxx-0000",
    amexCardNumber: "0000-00000000-000",
    amexCardCvv: "0000",
    bankAccountNumber: "00000000000000000",
    creditCardNumber: "0000-0000-0000-0000",
    creditCardCvv: "000",
    entityKey: "0000-0000-0000-0000",
    integer: integerMask,
    letters: /^[a-zA-Z]+$/,
    localDate: localDateMask,
    monthYear: monthYearMask,
    monthYear2: monthYear2Mask,
    phone: "(000) 000-0000",
    ssn: "000-00-0000",
    digitsLast4: "0000",
    routingNumber: "000000000",
    siteKey: {
        mask: /^[a-zA-Z0-9- ]+$/,
        prepare: function(str) {
            return str.toLowerCase().replace(/\s+/g, "-")
        },
    },
    state: "aa",
    star: StarMask,
    zipCode: "00000",
    upperCase(mask = /^\w+$/) {
        return {
            mask,
            prepare: function(str) {
                return str.toUpperCase()
            },
        }
    },
}
